import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, of, retry, switchMap } from 'rxjs';
import { python } from 'src/environments/environments';
import { AuthService } from 'src/app/core/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class CalendarBackendService {
  private readonly apiUrl = `${python.url_base}`;

  private calendarReadySubject = new BehaviorSubject<boolean>(false);
  public calendarReady$: Observable<boolean> = this.calendarReadySubject.asObservable();

  // Token de aplicación obtenido del backend (Client Credentials Flow)
  private appToken: string | null = null;

  // Email del doctor para llamadas Graph API (/users/{email}/events)
  private readonly doctorEmail = 'tomas.p@agencycic.com';

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}


  /* ========================================================== GETTERS ========================================================== */

  /** Token de aplicación del backend para llamadas a Microsoft Graph API */
  getAccessToken(): string | null {
    return this.appToken;
  }

  /** Email del doctor para construir URLs de Graph API */
  getDoctorEmail(): string {
    return this.doctorEmail;
  }

  /** ¿Ya se obtuvo el token del backend? */
  isCalendarReady(): boolean {
    return !!this.appToken;
  }


  /* ========================================================== METHODS ========================================================== */

  /**
   * Login programático con Microsoft vía backend (Client Credentials Flow).
   * El backend se autentica con Client ID + Client Secret (sin usuario).
   * Sigue el mismo patrón que getPqrData() de CrmPqrsServiceService.
   */
  loginMicrosoft(): Observable<{ success: boolean; token?: string; message?: string }> {
    const headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    const urlResource: string = `${this.apiUrl}/login-microsoft-calendar`;

    return this.authService.performProtectedRequest(() =>
      this.http.post<{ success: boolean; token?: string; message?: string }>(
        urlResource,
        JSON.stringify({}),
        {
          headers,
          withCredentials: true,
        }
      )
    )
    .pipe(
      retry(1),
      switchMap(response => {
        if (response.success) {
          // Almacenar el token de aplicación del backend
          this.appToken = response.token || null;
          this.calendarReadySubject.next(true);
          return of({ success: true, token: response.token, message: 'Login Microsoft exitoso' });
        } else {
          return of({ success: false, message: response.message || 'Error en login Microsoft' });
        }
      }),
      catchError(error => of({ success: false, message: error?.message || 'Error al conectar con el servidor' }))
    );
  }
}